module.exports = __webpack_public_path__ + "img/4.01ed8732.png";